export const actions = {
  setPrevRoute({ commit }, route) {
    commit('SET_PREV_ROUTE', route);
  }
};
